import React from 'react'
import { usePostRequest } from '../hooks/request'
import { INCOME_QUARTERLY_LIST } from '../urls'
import IncomeQuarterlyForm from './IncomeQuarterlyForm'

export default function IncomeQuarterlyCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: INCOME_QUARTERLY_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>

            <b>Добавить</b><br /><br />
            <IncomeQuarterlyForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
